import {
  Card,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Link } from "react-router-dom";
import { Controller } from "react-hook-form";
import { logEvent } from "../../../utils/analytics";
import { Button, TextField, Box } from "@mui/material";
import { Add, Remove } from "@mui/icons-material";
import './ServiceCard.css';
import dayjs from "dayjs";
import toast from "react-hot-toast";

function ServiceCard(props) {
  const {
    i,
    increaseQuantity,
    decreaseQuantity,
    handleOrderClick,
    selectedDate,
    setSelectedDate,
    quantityCounts,
    type,
    control,
    shouldDisableDate,
  } = props;

  const handleImageClick = (service) => {
    logEvent("Service Interaction", "Image Clicked", service.title);
  };

  const handleDateChange = (date, service) => {
    setSelectedDate((prevDates) => ({
      ...prevDates,
      [service._id]: date,
    }));
    logEvent("Service Interaction", "Date Selected", service.title);
  };

  const handleQuantityChange = (action, service) => {
    logEvent(
      "Service Interaction",
      `Quantity ${action}`,
      `${service.title} (Current Quantity: ${quantityCounts[service._id] || 1})`
    );
  };

  // const handlePujaRequest = (service) => {
  //   logEvent("Service Interaction", "Puja Requested", service.title);
  //   handleOrderClick(service);
  // };

  return (
    <Card>
      <Grid container padding={1} spacing={1}>
        <Grid item xs={12} sx={{ borderRadius: 5 }}>
          {type !== "outSideTemple" ? (
            <Link
              to={`/services/${i.category_slug}/${i.slug}`}
              onClick={() => handleImageClick(i)}
            >
              <img
                style={{
                  width: "100%",
                  height: "280px",
                  borderRadius: 20,
                  padding: 10,
                  objectFit: "cover",
                }}
                src={i.image}
                alt={i.title}
              />
            </Link>
          ) : (
            <img
              style={{
                width: "100%",
                height: "300px",
                borderRadius: 20,
                padding: 10,
                objectFit: "cover",
              }}
              src={i.image}
              alt={i.title}
            />
          )}
        </Grid>
        <Grid item xs={12} sx={{ textAlign: "center", height: 50, mb: 1 }}>
          <h5 className="mb-0 religious-services-title">{i.title}</h5>
        </Grid>

        <Grid item xs={12}>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={type === "atTemple" ? 8 : 12}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Select a date"
                  slotProps={{ textField: { fullWidth: true, size: "small" } }}
                  value={selectedDate[i._id]}
                  onChange={(date) => handleDateChange(date, i)}
                  shouldDisableDate={(date) => shouldDisableDate(date, i)}
                />
              </LocalizationProvider>
            </Grid>

            {type === "atTemple" && (
              <Grid item xs={4} sm={4} id="attemple">
                <Box className="input-group" sx={{ display: 'flex', alignItems: 'stretch', height: '40px' }}>
                  <Button
                    className="quantity-btn"
                    variant="contained"
                    color="primary"
                    disableElevation
                    onClick={() => {
                      decreaseQuantity(i._id);
                      handleQuantityChange("Decreased", i);
                    }}
                  >
                    <Remove sx={{ color: 'white' }} fontSize="small" />
                  </Button>
                  
                  <TextField
                    variant="outlined"
                    type="text"
                    className="form-control"
                    value={quantityCounts[i._id] || 1}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        height: '100%',
                        borderRadius: 0,
                        textAlign: 'center',
                        '& .MuiOutlinedInput-input': {
                          textAlign: 'center',
                          padding: '8px 0',
                        },
                        '& fieldset': {
                          borderRadius: 0,
                          borderLeft: 0,
                          borderRight: 0,
                        },
                      }
                    }}
                    sx={{
                      width: '100%',
                      '& .MuiInputBase-root': {
                        height: '100%',
                      }
                    }}
                  />
                  
                  <Button
                    variant="contained"
                    color="primary"
                    className="quantity-btn"
                    disableElevation
                    onClick={() => {
                      increaseQuantity(i._id);
                      handleQuantityChange("Increased", i);
                    }}
                  >
                    <Add sx={{ color: 'white' }} fontSize="small" />
                  </Button>
                </Box>
              </Grid>
            )}
          </Grid>
        </Grid>

        {type === "outSideTemple" && (
          <Grid item xs={12}>
            <Controller
              control={control}
              name={`items[${i._id}].location`}
              render={({ field }) => (
                <FormControl key={field.value} fullWidth size="small">
                  <InputLabel id={`location-label-${i._id}`}>
                    Location
                  </InputLabel>
                  <Select
                    {...field}
                    labelId={`location-label-${i._id}`}
                    label="Location"
                  >
                    <MenuItem value={"0-50miles"}>0 - 50 miles</MenuItem>
                    <MenuItem value={"50-100miles"}>50 - 100 miles</MenuItem>
                  </Select>
                </FormControl>
              )}
            />
          </Grid>
        )}

        <Grid item xs={12} mt={2}>
          <Grid container alignItems="center" spacing={1}>
            <Grid item xs={8}>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                className="request_puja_btn"
                disableElevation
                onClick={() => {
                  if(dayjs(selectedDate[i._id]).isBefore(dayjs(), 'day')){
                    toast.error('Please do not select past date')
                    return;
                  }
                  handleOrderClick(i);
                  logEvent(
                    "Service Interaction",
                    "Service Requested",
                    `${i.title} - $${i.amount}`
                  );
                }}
              >
                Request Puja
              </Button>
            </Grid>
            <Grid item xs={4} sx={{ textAlign: "center" }}>
              <h2 className="religious-subtitle">
                $ {i.amount !== 0 ? i.amount : "-"}
              </h2>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <div
            className="service-content-bdr truncate"
            dangerouslySetInnerHTML={{
              __html: i?.description,
            }}
          />
        </Grid>
      </Grid>
    </Card>
  );
}

export default ServiceCard;